<!--
  Custom icon: Robot / AI Bot — for AI model / workspace menus.
  Demonstrates the PURE CSS VARIABLE approach:
    • No JS theme import needed inside the icon
    • Colors are driven entirely by CSS custom properties
    • Set --icon-primary / --icon-accent on a parent element
      (or let the global theme CSS set them)

  Global CSS setup needed (add to App.vue <style> or a global CSS file):

    :root, .theme-dark  { --icon-primary: #e2e8f0; --icon-accent: #a78bfa; }
    .theme-light        { --icon-primary: #1e293b; --icon-accent: #6366f1; }

  Usage:
    <el-icon :size="24"><IconRobot /></el-icon>
    <IconRobot class="my-robot" />   <!-- style via CSS -->
-->
<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <!-- Antenna -->
    <line x1="12" y1="1.5" x2="12" y2="4.5" stroke="var(--icon-primary, currentColor)" stroke-width="1.5" stroke-linecap="round" />
    <circle cx="12" cy="1.5" r="1" fill="var(--icon-accent, currentColor)" />
    <!-- Head -->
    <rect x="4" y="4.5" width="16" height="11" rx="3" fill="var(--icon-primary, currentColor)" opacity="0.15" stroke="var(--icon-primary, currentColor)" stroke-width="1.5" />
    <!-- Eyes -->
    <circle cx="9" cy="10" r="1.5" fill="var(--icon-accent, currentColor)" />
    <circle cx="15" cy="10" r="1.5" fill="var(--icon-accent, currentColor)" />
    <!-- Mouth -->
    <rect x="8.5" y="13" width="7" height="1.2" rx="0.6" fill="var(--icon-primary, currentColor)" opacity="0.7" />
    <!-- Neck -->
    <line x1="12" y1="15.5" x2="12" y2="17.5" stroke="var(--icon-primary, currentColor)" stroke-width="1.5" stroke-linecap="round" />
    <!-- Body -->
    <rect x="6" y="17.5" width="12" height="5" rx="2" fill="var(--icon-primary, currentColor)" opacity="0.15" stroke="var(--icon-primary, currentColor)" stroke-width="1.5" />
    <!-- Body center dot -->
    <circle cx="12" cy="20" r="1" fill="var(--icon-accent, currentColor)" />
  </svg>
</template>
